angular.module('zc.zenclerkS')
  .directive('masterOnly', masterOnly);

masterOnly.$inject = ['Devise'];
function masterOnly(Devise) {
  return {
    restrict: 'A',
    link: link
  };

  function link(scope, elem, attrs) {
    const originalDisplay = elem.css('display');
    // hide initially!
    elem.css({display: 'none'});

    Devise.getCurrentUser().then(user => {
      if(user && Devise.isMaster()) {
        elem.css({display: originalDisplay});
      }

      scope.$watch(() => _.get(Devise.currentUser, 'role'), () => {
        if(!user || !Devise.isMaster()) {
          elem.css({display: 'none'});
        } else {
          elem.css({display: originalDisplay});
        }
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/master_only/master_only.directive.js